import React from 'react';
import UISidebar2 from './UISidebar2';

const UIBeats = ({ selectedTab, onTabChange, addClickableWrapper = false, pageClassName = '', enableClicking = false }) => {
  return (
    <div className={pageClassName}>
      <div className={`flex gap-8 ui-ideate ${addClickableWrapper ? 'ui-clickable-wrapper' : ''}`}>
        <UISidebar2 selectedTab={selectedTab} onTabChange={onTabChange} enableClicking={enableClicking} />
        <div className="ui-canvas">
          <div className="fake-timeline ui-timeline">
            <div className="fake-timeline-list">
              <div className="fake-timeline-list-item bordered">Acts</div>
              <div className="fake-timeline-list-item bordered">Sequences</div>
              <div className="fake-timeline-list-item">Scenes</div>
            </div>
            <div className="fake-timeline-content">
              <div className="fake-timeline-column">
                <div className="fake-timeline-content-item-title blurple">Act 1</div>
                <div className="fake-timeline-content-sequence-title">Opening</div>
                <div className="fake-timeline-scenes">
                  <div className="fake-timeline-content-beat-title">Cultural Interviews</div>
                </div>
              </div>
              <div className="fake-timeline-column">
                <div className="fake-timeline-content-item-title orange">Act 2</div>
                <div className="fake-timeline-content-sequence-title">Meeting Vanessa</div>
                <div className="fake-timeline-scenes">
                  <div className="fake-timeline-content-beat-title">Airport Lounging</div>
                  <div className="fake-timeline-content-beat-title">Two World's, One Bed</div>
                </div>
              </div>
              <div className="fake-timeline-column">
                <div className="fake-timeline-content-item-title lime">Act 3</div>
                <div className="fake-timeline-content-sequence-title">The Orbit Shift</div>
                <div className="fake-timeline-scenes">
                  <div className="fake-timeline-content-beat-title">Bye Jonah</div>
                </div>
              </div>
              <div className="fake-timeline-column">
                <div className="fake-timeline-content-item-title unassigned">Unassigned</div>
              </div>
            </div>
            <div className="fake-ui-empty-timeline"></div>

          </div>
          <div className="fake-beat one">
            <div className="flex flex-col space-between">
              <div class="flex flex-column gap-8">
                <p className="fake-beat-title">Cultural Interviews</p>
                <div className="hero-beat-placeholder"></div>
                <div className="hero-beat-placeholder w-60"></div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="act-chip" style={{ background: '#C9D1FF' }}>Act 1</div>
              <div className="sequence-chip">Opening</div>
            </div>
          </div>
          <div className="fake-beat two">
            <div className="flex flex-col space-between">
              <div class="flex flex-column gap-8">
                <p className="fake-beat-title">Airport Lounging</p>
                <div className="hero-beat-placeholder w-90"></div>
                <div className="hero-beat-placeholder w-80"></div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="act-chip" style={{ background: '#C9D1FF' }}>Act 1</div>
              <div className="sequence-chip">Meeting Vanessa</div>
            </div>
          </div>
          <div className="fake-beat ui">
            <div className="flex flex-col space-between">
              <div class="flex flex-column gap-8">
                <p className="fake-beat-title">Bye Jonah</p>
                <div className="hero-beat-placeholder"></div>
                <div className="hero-beat-placeholder w-70"></div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="act-chip" style={{ background: '#C9D1FF' }}>Act 1</div>
              <div className="sequence-chip">The Orbit Shift</div>
            </div>
          </div>

          <div className="fake-beat ui-2">
            <div className="flex flex-col space-between">
              <div class="flex flex-column gap-8">
                <p className="fake-beat-title">Two World's, One Bed</p>
                <div className="hero-beat-placeholder"></div>
                <div className="hero-beat-placeholder w-70"></div>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="act-chip" style={{ background: '#C9D1FF' }}>Act 1</div>
              <div className="sequence-chip">Meeting Vanessa</div>
            </div>
          </div>
          <div className="fake-toolbox absolute">
              <div class="flex gap-2 items-center">
                <div className="fake-toolbox-icon first-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_445_6056)">
                      <rect x="0.625" y="0.625" width="14.75" height="14.75" rx="2.80357" stroke="#272729" stroke-width="1.25" />
                      <path d="M4 4.57153H10.8571M4 7.42868H8" stroke="#272729" stroke-width="1.25" stroke-linecap="round" />
                    </g>
                  </svg>
                </div>
                <div className="selector">
                  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.11987 2.91992L3.99987 5.79992L6.87987 2.91992" stroke="#272729" stroke-width="1.08" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
              <div className="icon-divider"></div>
              <div class="flex">
                <div className="fake-toolbox-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.625" y="0.625" width="14.75" height="14.75" rx="3.375" stroke="#272729" stroke-width="1.25" />
                    <rect x="6.33936" y="6.33936" width="9.03571" height="9.03571" rx="3.375" stroke="#272729" stroke-width="1.25" />
                  </svg>
                </div>
                <div className="fake-toolbox-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.625" y="0.625" width="14.75" height="5.60714" rx="1.375" stroke="#272729" stroke-width="1.25" />
                    <rect x="0.625" y="9.76782" width="14.75" height="5.60714" rx="1.375" stroke="#272729" stroke-width="1.25" />
                  </svg>
                </div>
                <div className="fake-toolbox-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.604004" y="1" width="14.7925" height="1.32075" rx="0.660377" fill="#272729" />
                    <rect x="0.604004" y="5.22632" width="14.7925" height="1.32075" rx="0.660377" fill="#272729" />
                    <rect x="0.604004" y="9.45288" width="14.7925" height="1.32075" rx="0.660377" fill="#272729" />
                    <rect x="0.604004" y="13.6792" width="14.7925" height="1.32075" rx="0.660377" fill="#272729" />
                  </svg>
                </div>
              </div>
              <div className="icon-divider"></div>
              <div className="flex">
                <div className="fake-toolbox-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2285_3308)">
                      <path d="M4.74512 3.93237V12.068" stroke="#272729" stroke-width="1.255" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M8 5.01685V10.9829" stroke="#272729" stroke-width="1.255" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M11.2549 6.10156V9.89817" stroke="#272729" stroke-width="1.255" stroke-linecap="round" stroke-linejoin="round" />
                      <rect x="0.625" y="0.625" width="14.75" height="14.75" rx="3.375" stroke="#272729" stroke-width="1.25" />
                    </g>
                  </svg>
                </div>
              </div>
              <div className="icon-divider"></div>
              <div className="fake-switch">
                <div className="fake-switch-toggle">
                  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="2.47266" y="8.13818" width="8.94706" height="2.75294" rx="0.688235" stroke="#272729" stroke-width="0.75" />
                    <rect x="0.407959" y="3.32056" width="9.63529" height="2.75294" rx="0.688235" stroke="#272729" stroke-width="0.75" />
                    <path d="M6.08594 1.25598V12.956" stroke="#272729" stroke-width="0.75" stroke-linecap="round" />
                  </svg>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default UIBeats;
